const HowToSection = () => {
    return (
        <>
            <section className="processes text-center p-top-70">
                <div className="container">
                    <div className="process-panels-container tram-hts-container-two-col">
                        <div className="process-panel tram-hts-panel">
                            <h2 className="process-name tram-hts-heading">Step 1 — Set Up Your Evaluation</h2>
                            <div className="tram-hts-image-section">
                                <img src="steps/step_1.png" alt="Set up evaluation" className="tram-hts-two-col-image" />
                            </div>
                            <p className="process-desc tram-hts-two-col-content">Configure the assessment protocol for your patient. Choose from validated questionnaires and sensor-based assessments tailored to the injury type and recovery stage.</p>
                        </div>
                        <div className="process-panel tram-hts-panel">
                            <h2 className="process-name tram-hts-heading">Step 2 — Invite Your Patient</h2>
                            <div className="tram-hts-image-section">
                                <img src="steps/step_2.png" alt="Invite patient" className="tram-hts-two-col-image" />
                            </div>
                            <p className="process-desc tram-hts-two-col-content">With one click, invite the patient or their parent to complete assessments at home on their own smartphone. Clear audiovisual instructions guide every step.</p>
                        </div>
                    </div>
                    <div className="process-panels-container tram-hts-container-one-col">
                        <div className="process-panel tram-hts-panel">
                            <h2 className="process-name tram-hts-heading">Step 3 — Monitor and Act</h2>
                            <div className="tram-hts-image-section tram-hts-multiple-images">
                                <img src="steps/step_3_1.png" alt="Monitor recovery" />
                                <img src="steps/step_3_2.png" alt="Review data" />
                                <img src="steps/step_3_3.png" alt="AI alerts" />
                            </div>
                            <p className="process-desc tram-hts-one-col-content">Review objective recovery data on your dashboard. AI-powered alerts flag patients who need attention — so you can focus your clinic time where it matters most.</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default HowToSection;
